import type { HeroDirectoryEntry } from './directory-types';

type RoutableHero = { id: string; gameId: string };

const sequentialRouteGames = new Set(['guardian-tales']);

function gameHeroes<T extends RoutableHero>(
  gameId: string,
  directory: readonly T[],
) {
  return directory.filter((hero) => hero.gameId === gameId);
}

export function heroRouteId(
  hero: RoutableHero,
  directory: readonly RoutableHero[],
) {
  if (!sequentialRouteGames.has(hero.gameId)) return hero.id;
  const index = gameHeroes(hero.gameId, directory).findIndex(
    (item) => item.id === hero.id,
  );
  return index >= 0 ? String(index + 1) : hero.id;
}

export function heroArchiveUrl(
  hero: RoutableHero,
  directory: readonly RoutableHero[],
) {
  return `/${hero.gameId}/t${heroRouteId(hero, directory)}`;
}

export function resolveHeroRouteId(
  gameId: string,
  routeId: string,
  directory: readonly HeroDirectoryEntry[],
) {
  if (!sequentialRouteGames.has(gameId) || !/^\d+$/.test(routeId)) {
    return routeId;
  }
  const index = Number(routeId) - 1;
  return index >= 0 ? gameHeroes(gameId, directory)[index]?.id : undefined;
}
